import axios from 'axios'
const API_URL = process.env.REACT_APP_API_URL


export function getOneSuscription(id:Number) {
    return axios.get(API_URL+'/v1/suscription/'+id)
  }

export function getOneSuscriptionGral(id:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+id+'?tenantId='+tenant)
  }

export function getOneAccountCloud(id:String,idCloud:String) {
    return axios.get(API_URL+'/v1/suscription/'+id+'/cloud/'+idCloud)
  }

export function getHistorical(SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ExceededTrafic')
  }

export function getHistoricalglobal(SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ExceededTrafic?tenantId='+tenant)
  }

export function getFacturas(SuscriptionId:Number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ListBilling')
  }

export function getFacturasGlobal(SuscriptionId:Number,tenant:number) {
    return axios.get(API_URL+'/v1/suscription/'+SuscriptionId+'/ListBilling?tenantId='+tenant)
  }





